import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './SecondaryButton.css';
import Loading from '../Loading';
// import { trackPUAnalytics } from '../../services/Mixpanel';

const SecondaryButton = ({
    children,
    className,
    loading,
    disabled,
    style,
    color,
    type,
    dispatch, // eslint-disable-line
    as,
    ...props
}) => {
    // const trackAnalytics = (clickButton) => trackPUAnalytics('PathwayU:Land', {
    //     clickButton,
    //   });
    const elementType = props.to || props.href ? undefined : type;
    let ButtonEl = as;
    if (props.href) {
        ButtonEl = 'a';
    } else if (props.to) {
        ButtonEl = Link;
    }
    return (<ButtonEl
        className={cx(styles.button, className)}
        disabled={loading || disabled}
        style={{
            color,
            cursor: disabled ? 'default' : 'pointer',
            borderColor: color,
            ...style,
        }}
        type={elementType}
        {...props}
    >
        {loading ? <Loading size={20} /> : children}
    </ButtonEl>);
};

SecondaryButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    type: PropTypes.string,
    style: PropTypes.object,
    to: PropTypes.string,
    href: PropTypes.string,
    as: PropTypes.string,
};

SecondaryButton.defaultProps = {
    style: {},
    type: 'button',
    as: 'button',
};

export default connect(({ theme }) => ({
    color: theme.primaryColor,
}))(SecondaryButton);



// WEBPACK FOOTER //
// ./src/client/Components/SecondaryButton/SecondaryButton.js